<script lang="ts" setup>
defineProps({
  hideAtBottom: {
    default: true,
    type: Boolean,
  },
})

const pageBottomReached = ref(false)

const promptStore = usePromptStore()
const { routeNameWithoutLocale } = useNavigation()

onBeforeMount(() => {
  if (import.meta.client) {
    window.addEventListener('scroll', onScroll)
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll)
})

function onScroll() {
  pageBottomReached.value = window.innerHeight + window.scrollY >= document.body.offsetHeight
}
</script>

<template>
  <ClientOnly>
    <div
      class="transition-base fixed bottom-40 left-1/2 z-20 w-full -translate-x-1/2 transform-gpu px-6 sm:w-[520px] md:w-[620px] lg:w-[720px]"
      :class="{
        'bottom-40 md:bottom-48': promptStore.isVisible,
        'bottom-20 md:bottom-28': !promptStore.isVisible,
      }"
    >
      <Transition
        enter-active-class="spring-duration-150 spring-bounce-20 transform-gpu"
        enter-from-class="translate-y-full opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="spring-duration-150 spring-bounce-20 transform-gpu"
        leave-from-class="translate-y-0 opacity-100"
        leave-to-class="translate-y-full opacity-0"
        mode="out-in"
      >
        <SubscriptionStatusAlert
          v-if="
            (hideAtBottom ? !pageBottomReached : true)
              && !String(routeNameWithoutLocale).startsWith('auth-')
              && !String(routeNameWithoutLocale).startsWith('pricing')
              && !String(routeNameWithoutLocale).startsWith('settings')
              && String(routeNameWithoutLocale) !== 'index'"
        />
      </Transition>
    </div>
  </ClientOnly>
</template>
